import appSettings from 'wanderu-config';
import { isLocalStorageAvailable } from 'wanderu-utils';

const KEY = 'failedLoggingEvents';

function saveFailedEvents(events) {
    if (!appSettings.env.isClient || !isLocalStorageAvailable()) {
        return;
    }

    window.localStorage.setItem(KEY, JSON.stringify([..._getFailedEvents(), ...events]));
}

function _getFailedEvents() {
    try {
        return JSON.parse(window.localStorage.getItem(KEY)) || [];
    } catch (ex) {
        return [];
    }
}

function removeFailedEvents() {
    if (!appSettings.env.isClient || !isLocalStorageAvailable()) {
        return [];
    }

    const failedEvents = _getFailedEvents();
    window.localStorage.removeItem(KEY);

    return failedEvents;
}

export default {
    saveFailedEvents,
    removeFailedEvents,
};
